export const ENTITY_NAMES = {
    PERSON: "Person",
    LEAD: "Lead",
    DMC_LEAD: "DmcLead",
    CLIENT: "Client",
    INVENTORY_ITINERARY: "Itinerary",
    QUOTE: "ItineraryQuote",
    DMC_QUOTE: "DmcItineraryQuote",
    TASK: "Task",
    INVOICE: "Invoice",
    PAYMENT: "Payment",
    VOUCHER: "Voucher",
    CONTACT: "Contact",
    CALL: "CallData",
    VISA: "Visa",
    VISA_CHECKLIST: "Visa Checklist",
    LEAD_STATUS: "LeadStatus",
    LEAD_SOURCE: "LeadSource",
    TRAVEL_SERVICES: "TravelServices",
    USER: "User",
    TASK_PRIORITY: "TaskPriority",
    QUOTE_STATUS: "QuoteStatus",
    VOUCHER_STATUS: "VoucherStatus",
    INVOICE_STATUS: "InvoiceStatus",
    TASK_STATUS: "TaskStatus",
    INVENTORY_STATUS: "InventoryStatus",
    DMC_PACKAGE: "DmcPackage",
    DMC_OFFERS: "DmcOffers",
    INVENTORY_HOTELS: "Hotels",
    INVENTORY_VEHICLES: "Transfers",
    PASSENGER: "Guest",
    DMC_CONTACT: "DmcContact",
    VENDOR_CONTACT: "VendorContact",
    AGENT_CONTACT: "VendorContact",
    ORGANIAZATION: "Organization",
    WHATSAPP_CAMPAIGN: "WhatsappCampaign"
}

export const RECORD_STATUS_VALUES = {
    NEW: "New",
    CONTACTED: "Contacted",
    QUOTATION_PENDING: "Quotation Pending",
    JUNK: "Junk",
    LOST: "LOST",
    PENDING: "Pending",
    ISSUED: "Issued",
    DRAFT: "Draft",
    INACTIVE: "Inactive",
    APPROVED: "Approved",
    ACTIVE: "Active",
    CONVERTED: "Converted",
    COMPLETED: "Completed",
    QUOTE_CREATED: "Quote Created",
    IN_PROGRESS: "In Progress",
    ON_HOLD: "On Hold",
    CANCELLED: "Cancelled",
    NOT_STARTED: "Not Started",
    CONFIRMED: "Confirmed",
    FAILED: "Failed"
}


export const LEAD_SOURCE_VALUE = {
    SOCIAL_MEDIA: "Social Media",
    WEBSITE: "Website",
    ADS: "Ads",
    COLD_CALL: "Cold Call",
    REFERRAL: "Referral",
    EXISTING_CUSTOMER: "Existing Customer",
    EMAIL_MARKETING: "Email Marketing"
};

export const TRAVEL_SERVICES = {
    TOUR_PACKAGE: "Tour Package",
    TRANSPORTATION: "Transportations",
    HOTELS: "Hotels",
    SIGHTSEEING: "Sightseeing",
    TRANSFERS: "Transfers",
    VISA: "Visa"
}

export const CONTACT_TYPES = {
    PASSENGER: "Passenger",
    DMC: "DMC",
    VENDOR: "Vendor",
    AGENT: "Agent"
}

export const TRANSPORTATION_TYPES = {
    FLIGHT: "flight",
    BUS: "bus",
    TRAIN: "train",
    CAR: "car",
    FERRY: "ferry",
    CRUISE: "cruise"
}

export const TABLE_OPTION_VALUES = {
    VIEW: "details",
    EDIT: "edit",
    DELETE: "delete",
    TASK: "task",
    ADD_PAYMENT: "addPayment",
    APPROVE: "approve",
    DOWNLOAD: "download",
    FINALIZE: "finalize",
    CONVERT: "convert",
    FINALIZE_AND_CONVERT: "finalizeAndConvert",
    MAKE_A_CLONE: "makeAClone",
    SHOW_AUDIT: "showAuditHistory",
    GENERATE_INVOICE: "generateInvoice"
}

export const MEAL_PLANS = {
    BREAKFAST: "Breakfast",
    LUNCH: "Lunch",
    DINNER: "Dinner",
    ALL_INCLUSION: "All Inclusive"
}

export const ROUTE_CRAFT_TYPES = {
    DAY_PLANNER: "DayToDayPlan",
    FREE_TEXT: "FreeText"
}

export const OCCUPENCY_TYPES = {
    SGL: 'sgl',
    DBL: 'dbl',
    TPL: 'tpl'
}

export const ORGANIZATION_TYPES = {
    AGENT: 'Agent',
    DMC: 'Dmc',
    AGENT_AND_DMC: 'Agent and Dmc'
}

export const USER_ROLES = {
    CLIENT_ADMIN: "ClientAdmin",
    CLIENT_MANAGER: "ClientManager",
    CLIENT_SUPERVISOR: "ClientSupervisor",
    CLIENT_USER: "ClientUser",
    CLIENT_VISA: "ClientVisa",
    CLIENT_ACCOUNTANT: "ClientAccountant",
    CLIENT_DEMO: "ClientDemo"
}

export const ONBOARDING_METHODS = {
    TripMeld: 'TripMeld',
    Social: 'Social',
    Events: 'Events',
    Website: 'Website',
    WhatsApp: 'WhatsApp'
}